import { Container } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import { Generator } from "../../../components/Generator";
import { Grid } from "../../../components/Grid";
import { Heading } from "../../../components/Heading";
import { Sidebar } from "../../../components/Navigation/Sidebar";
import { FormType } from "../../../components/enums";
import {
  usePreventRefresh,
  useScrollDocument,
  useShouldRedirectToHomepage,
} from "../../../hooks";
import { Url } from "../../../router/enums";
import { selectIsFormValidated } from "../../../store/HOC/genericUI.selectors";
import { selectUIData } from "../Incident/incident.selectors";

import styles from "./Perpetrator.module.scss";
import {
  generalDataForms,
  perpetratorDataForm,
  ownerDetailDataForm,
  companyDataForms,
} from "./form";
import {
  shouldDisplayCompanyOwner,
  shouldDisplayCompanyPerpetrator,
} from "./perpetrator.selectors";

export const Perpetrator = (): JSX.Element => {
  useShouldRedirectToHomepage(selectIsFormValidated(selectUIData));
  useScrollDocument();
  usePreventRefresh();

  return (
    <Container className={styles.container}>
      <Heading component="h1" variant="h1" spacingBottom={4}>
        Formularz zgłoszenia szkody
      </Heading>
      <Grid
        container
        alignItems="flex-start"
        className={styles.page}
        spacingInnerLeft={{ xs: 5, sm: 10 }}
        spacingInnerRight={{ xs: 5, sm: 10 }}
        direction="row"
      >
        <Sidebar currentRoute={Url.AC_PERPETRATOR} type={FormType.AC} />
        <Generator
          form={[
            generalDataForms.main,
            generalDataForms.perpetratorId,
            perpetratorDataForm.main,
            perpetratorDataForm.addressWhileDriving,
            generalDataForms.carOwner,
            ownerDetailDataForm.owner,
            ownerDetailDataForm.address,
            ownerDetailDataForm.car,
            ownerDetailDataForm.documents,
            perpetratorDataForm.address,
            perpetratorDataForm.insurance,
            companyDataForms.form(
              "Dane właściciela pojazdu",
              shouldDisplayCompanyPerpetrator
            ),
            companyDataForms.form("Dane sprawcy", shouldDisplayCompanyOwner),
            companyDataForms.insurance,
          ]}
          render={(generatedForm) => (
            <Grid item xs={12} md={8}>
              {generatedForm}
            </Grid>
          )}
        />
      </Grid>
    </Container>
  );
};
